import accueilenfants from './accueilenfants';
import infoslegales from './infoslegales';
import subheader from './subheader';
import aliments from './alimentation/aliments';
import trancheagealimentation from './alimentation/trancheagealimentation';
import liensutiles from './liensutiles';
import developpement from './developpement';
import todolist from './todolist';
import rdvmedicaux from './todolist/rdvmedicaux';
import vaccins from './todolist/vaccins';

export default {
	infoslegales,
	accueilenfants,
	subheader,
	aliments,
	trancheagealimentation,
	liensutiles,
	developpement,
	todolist,
	rdvmedicaux,
	vaccins
};
